import * as ex from "excalibur";
import { CONFIG } from "../config";
import { landscapeImage, BRIDGE_SPRITE } from "./LandscapeAtlas";
export const buildingsImage = new ex.ImageSource("/assets/sprites/buildings.png", {
    filtering: ex.ImageFiltering.Pixel,
});
// Kenney building tiles are 99px wide at source; landscape tiles are 132px wide.
// Scaling uniformly to TILE_WIDTH=64 preserves the 2:1 isometric diamond ratio:
//   source diamond height = 99/2 = 49.5  →  dest = 49.5 * (64/99) = 32 = TILE_HEIGHT ✓
const BUILDING_SRC_W = 99;
const BUILDING_DEST_W = CONFIG.TILE_WIDTH; // 64
// Base tile (052) is 85px tall → dest 55px. This drives the GraphicsGroup height and anchor.
const BASE_SRC_H = 85;
export const BUILDING_DEST_H = Math.round((BASE_SRC_H * BUILDING_DEST_W) / BUILDING_SRC_W); // 55
// Aligns a graphic's base with tile.center, given its destination height. The user-corrected
// building anchor is this formula at BUILDING_DEST_H; flat ground-overlay actors (the bridge)
// use it at their own (much smaller) destH instead.
export function anchorYForHeight(destH) {
    return 1 - CONFIG.TILE_HEIGHT / 2 / destH;
}
export const BUILDING_ANCHOR_Y = anchorYForHeight(BUILDING_DEST_H);
const ATLAS = {
    // townhall
    buildingTiles_052: { x: 497, y: 60, width: BUILDING_SRC_W, height: 85 },
    // company base + roof
    buildingTiles_055: { x: 496, y: 1632, width: BUILDING_SRC_W, height: 85 },
    buildingTiles_074: { x: 397, y: 1209, width: BUILDING_SRC_W, height: 61 },
    // bastei (landmark tower): base + top accent
    buildingTiles_007: { x: 596, y: 278, width: BUILDING_SRC_W, height: 85 },
    buildingTiles_084: { x: 497, y: 206, width: BUILDING_SRC_W, height: 63 },
    // police (civic): base + top accent
    buildingTiles_016: { x: 596, y: 533, width: BUILDING_SRC_W, height: 85 },
    buildingTiles_097: { x: 497, y: 766, width: BUILDING_SRC_W, height: 61 },
    // park (low pavilion): single base tile
    buildingTiles_050: { x: 596, y: 448, width: BUILDING_SRC_W, height: 85 },
};
export function createBuildingTileSprite(name) {
    const rect = ATLAS[name];
    // Each tile scales uniformly by TILE_WIDTH/BUILDING_SRC_W; height varies per tile.
    const destH = Math.round((rect.height * BUILDING_DEST_W) / BUILDING_SRC_W);
    return new ex.Sprite({
        image: buildingsImage,
        sourceView: {
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
        },
        destSize: { width: BUILDING_DEST_W, height: destH },
    });
}
// Sprite layer stack per special building type — same rects the actors use.
function specialLayers(specialType) {
    switch (specialType) {
        case "bastei":
            return ["buildingTiles_007", "buildingTiles_084"];
        case "police":
            return ["buildingTiles_016", "buildingTiles_097"];
        default:
            return ["buildingTiles_050"]; // park + unknown
    }
}
// Rasterizes a special building's sprite composition onto a canvas at game resolution
// (64×55 px). Caller should display it at 2× via CSS (width: 128px, image-rendering: pixelated).
// Safe to call after the Excalibur loader has completed (buildingsImage is loaded).
export function renderBuildingPreview(specialType) {
    const canvas = document.createElement("canvas");
    canvas.width = BUILDING_DEST_W; // 64
    canvas.height = BUILDING_DEST_H; // 55
    canvas.style.imageRendering = "pixelated";
    const ctx = canvas.getContext("2d");
    if (!ctx)
        return canvas;
    ctx.imageSmoothingEnabled = false;
    if (specialType === "bridge") {
        const { rect, srcCropH, destH } = BRIDGE_SPRITE;
        ctx.drawImage(landscapeImage.image, rect.x, rect.y, rect.width, srcCropH, 0, 0, BUILDING_DEST_W, destH);
        return canvas;
    }
    for (const key of specialLayers(specialType)) {
        const rect = ATLAS[key];
        const destH = Math.round((rect.height * BUILDING_DEST_W) / BUILDING_SRC_W);
        ctx.drawImage(buildingsImage.image, rect.x, rect.y, rect.width, rect.height, 0, 0, BUILDING_DEST_W, destH);
    }
    return canvas;
}
